(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cancel-package-modal"] && !Shopify.designMode) return;
  try {
    const urlParams = new URLSearchParams(window.location.search);
  const headerId = urlParams.get('headerId');
  const detailId = urlParams.get('detailId');

  const dialogComponent = document.getElementById('cancel-package-modal-dialog');
  const cancelPackageLink = dialogComponent?.querySelector('#cancel-package');

  if (!!headerId || !!detailId) {
    cancelPackageLink?.style.setProperty('display', 'block');
  }

  const cancelButton = dialogComponent?.querySelector('#cancel-package-dialog-cancel-btn');
  cancelButton?.addEventListener('click', () => {
    window.location.href = '/a/package-builder';
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cpq-save-confirmation-modal"] && !Shopify.designMode) return;
  try {
    class CpqSaveModal {
    constructor() {
      this.modal = document.getElementById('cpq-save-modal');
      this.viewButton = this.modal?.querySelector('[data-action="view-saved-designs"]');
      this.closeButton = this.modal?.querySelector('[data-action="close"]');

      this.bindEvents();
    }

    bindEvents() {
      if (!this.modal) return;

      this.viewButton?.addEventListener('click', () => {
        window.location.href = '/pages/saved-designs';
      });

      const close = () => this.hide();
      this.closeButton?.addEventListener('click', close);
    }

    show() {
      this.modal?.showDialog();
    }

    hide() {
      this.modal?.closeDialog();
    }
  }

  window.cpqSaveModal = new CpqSaveModal();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cpq-view-modal"] && !Shopify.designMode) return;
  try {
    class CpqViewModal {
    #images = [];
    #details = [];

    constructor(images = [], details = []) {
      this.modal = document.getElementById('cpq-view-modal');
      this.imagesContainer = document.getElementById('cpq-images-container');
      this.tableBody = document.querySelector('#cpq-details-table tbody');

      // Clear initial content
      this.imagesContainer.innerHTML = '';
      this.tableBody.innerHTML = '';

      // Set initial data
      this.setData(images, details);
    }

    setData(images, details) {
      this.#images = images;
      this.#details = details;

      // Clear previous content
      this.imagesContainer.innerHTML = '';
      this.tableBody.innerHTML = '';

      // Setup images and details
      this.setupImages(this.#images);
      this.setupDetails(this.#details);
    }

    setupImages(images) {
      images.forEach((imageUrl) => {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = 'Product image';
        img.loading = 'lazy';
        this.imagesContainer.appendChild(img);
      });
    }

    setupDetails(details) {
      details
        .filter((detail) => detail.visible && !detail.name.toLowerCase().includes('image'))
        .forEach((detail) => {
          const row = document.createElement('tr');
          const nameCell = document.createElement('td');
          const valueCell = document.createElement('td');

          nameCell.textContent = detail.name;
          valueCell.textContent = detail.value || '-';

          row.appendChild(nameCell);
          row.appendChild(valueCell);
          this.tableBody.appendChild(row);
        });
    }

    show() {
      this.modal.showDialog();
    }
  }

  // Make it globally accessible
  window.cpqViewModal = new CpqViewModal();

  window.onbeforeprint = () => {
    const modal = document.getElementById('cpq-view-modal');
    // Store the original parent to put it back later
    window._modalParent = modal.parentNode;
    document.body.appendChild(modal);
  };

  window.onafterprint = () => {
    const modal = document.getElementById('cpq-view-modal');
    window._modalParent.appendChild(modal);
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["generic-modal"] && !Shopify.designMode) return;
  try {
    class GenericModal {
    #title = '';
    #body = '';

    constructor() {
      this.modal = document.getElementById('generic-modal');
      this.titleElement = document.getElementById('generic-modal-title');
      this.bodyElement = document.getElementById('generic-modal-body');
    }

    setContent(title, body) {
      this.#title = title || '';
      this.#body = body || '';

      this.titleElement.textContent = this.#title;
      this.bodyElement.innerHTML = this.#body;
    }

    show(title, body) {
      if (title !== undefined || body !== undefined) {
        this.setContent(title, body);
      }
      this.modal.showDialog();
    }

    hide() {
      this.modal.closeDialog();
    }
  }

  // Make it globally accessible
  window.genericModal = new GenericModal();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function openModal(modalId) {
      const modal = document.getElementById(modalId);
      if (!modal) return;

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Focus the close button for accessibility
      const closeButton = modal.querySelector('.product-modal__close');
      if (closeButton) {
        setTimeout(() => closeButton.focus(), 100);
      }
    }

    function closeModal(modalId) {
      const modal = document.getElementById(modalId);
      if (!modal) return;

      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      // Return focus to trigger button
      const trigger = document.querySelector(`[data-modal-trigger="${modalId}"]`);
      if (trigger) {
        trigger.focus();
      }
    }

    // Handle trigger clicks
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-modal-trigger]');
      if (trigger) {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal-trigger');
        openModal(modalId);
        return;
      }

      const closeBtn = e.target.closest('[data-modal-close]');
      if (closeBtn) {
        e.preventDefault();
        const modalId = closeBtn.getAttribute('data-modal-close');
        closeModal(modalId);
      }
    });

    // Handle escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const openModals = document.querySelectorAll('.product-modal[aria-hidden="false"]');
        openModals.forEach(function (modal) {
          closeModal(modal.id);
        });
      }
    });

    // Trap focus within modal
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;

      const openModal = document.querySelector('.product-modal[aria-hidden="false"]');
      if (!openModal) return;

      const focusableElements = openModal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    });

    // Ajax add-to-cart handler for modal
    document.addEventListener('submit', function (e) {
      var form =
        e.target.closest && e.target.closest('.product-modal__form')
          ? e.target.closest('.product-modal__form')
          : e.target.classList && e.target.classList.contains('product-modal__form')
          ? e.target
          : null;
      if (!form) return;
      e.preventDefault();

      var addButton = form.querySelector('button[type="submit"]');
      var originalText = addButton ? addButton.textContent : '';
      if (addButton) {
        addButton.textContent = 'Adding...';
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        addButton.classList.add('is-loading');
      }

      var variantInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var variantId = variantInput ? variantInput.value : null;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (!variantId) {
        if (addButton) {
          addButton.textContent = originalText;
          addButton.disabled = false;
        }
        alert('Unable to add product to cart (no variant selected).');
        return;
      }

      var items = [{ id: variantId, quantity: quantity }];

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          // Try to update cart drawer if present, otherwise redirect to cart
          var cartDrawer = document.querySelector('cart-drawer-component');
          var cartItems = cartDrawer ? cartDrawer.querySelector('.cart-items-component') : null;
          var cartSectionId = cartItems ? cartItems.dataset.sectionId : null;

          if (!cartDrawer || !cartItems || !cartSectionId) {
            window.location.href = '/cart';
            return;
          }

          fetch('/?section_id=' + cartSectionId)
            .then(function (resp) {
              return resp.text();
            })
            .then(function (htmlText) {
              var parser = new DOMParser();
              var newDoc = parser.parseFromString(htmlText, 'text/html');
              var newCartItems = newDoc.querySelector('.cart-items-component');
              var newCartHeader = newDoc.querySelector('.cart-drawer__header');
              var oldCartHeader = cartDrawer.querySelector('.cart-drawer__header');

              if (newCartItems && cartItems) cartItems.innerHTML = newCartItems.innerHTML;
              if (newCartHeader && oldCartHeader) oldCartHeader.innerHTML = newCartHeader.innerHTML;

              // Open the cart drawer so user sees the added item
              if (typeof cartDrawer.open === 'function') {
                try {
                  cartDrawer.open();
                } catch (e) {
                  /* ignore */
                }
              }

              // Dispatch a cart update event for other components
              try {
                document.dispatchEvent(
                  new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      sourceId: variantId,
                      data: { 
                        variantId: variantId, 
                        itemCount: quantity,
                        source: 'product-form-component'
                      },
                    },
                  })
                );
              } catch (e) {
                /* ignore */
              }

              if (addButton) {
                addButton.textContent = originalText;
                addButton.disabled = false;
                addButton.removeAttribute('aria-disabled');
                addButton.classList.remove('is-loading');
              }

              // Close modal after add
              var modal = form.closest('.product-modal');
              if (modal) {
                modal.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
              }
            })
            .catch(function (err) {
              console.error('Error refreshing cart drawer:', err);
              if (addButton) {
                addButton.textContent = originalText;
                addButton.disabled = false;
                addButton.removeAttribute('aria-disabled');
                addButton.classList.remove('is-loading');
              }
              window.location.href = '/cart';
            });
        })
        .catch(function (err) {
          console.error('Error adding to cart:', err);
          if (addButton) {
            addButton.textContent = originalText;
            addButton.disabled = false;
            addButton.removeAttribute('aria-disabled');
            addButton.classList.remove('is-loading');
          }
          alert('An error occurred while adding the item to cart.');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["remove-configuration"] && !Shopify.designMode) return;
  try {
    const urlParams = new URLSearchParams(window.location.search);
  const headerId = urlParams.get('headerId');
  const detailId = urlParams.get('detailId');

  const dialogComponent = document.getElementById('remove-configuration-dialog');
  const removeConfigLink = dialogComponent?.querySelector('#remove-configuration');

  if (!!headerId || !!detailId) {
    removeConfigLink?.style.setProperty('display', 'block');
  }

  const cancelButton = dialogComponent?.querySelector('#dialog-cancel-btn');
  cancelButton?.addEventListener('click', () => {
    window.location.href = window.location.pathname;
  });
  } catch(e) { console.error(e); }
})();

})();
